var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 23,
    viewBox: "0 0 39 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3534C0 11.7844 0.171205 12.1977 0.475952 12.5025C0.780698 12.8072 1.19402 12.9784 1.625 12.9784H33.4523L26.4778 19.9529C26.1817 20.2594 26.018 20.6699 26.0217 21.0959C26.0254 21.522 26.1963 21.9296 26.4975 22.2309C26.7988 22.5322 27.2064 22.703 27.6325 22.7068C28.0585 22.7105 28.469 22.5467 28.7755 22.2507L38.5255 12.5007C38.6759 12.3512 38.7952 12.1734 38.8766 11.9776C38.9581 11.7819 39 11.5719 39 11.3599V11.3534C39 11.1422 38.9578 10.9309 38.8733 10.7327C38.7923 10.5357 38.673 10.3567 38.5222 10.2062L28.7722 0.456157C28.4658 0.16015 28.0553 -0.003641 27.6292 6.14293e-05C27.2032 0.00376386 26.7956 0.174663 26.4943 0.475951C26.193 0.777239 26.0221 1.18481 26.0184 1.61088C26.0147 2.03695 26.1785 2.44743 26.4745 2.75391L33.4523 9.72841H1.625C1.19402 9.72841 0.780698 9.89961 0.475952 10.2044C0.171205 10.5091 0 10.9224 0 11.3534Z",
    fill: "url(#paint0_linear_2038_3493)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2038_3493",
    x1: -3.22556,
    y1: 5.06849,
    x2: 46.4213,
    y2: 14.5917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA5332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DA5332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78524"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.2af13d2a44db3e4d3c4d6ab36ecc9abc.svg";
export { ForwardRef as ReactComponent };